let stylesheet;
let styles = [];

function init() {
  stylesheet = document.createElement('style');
  stylesheet.id = 'dv-styles';
  document.head.appendChild(stylesheet);
  return stylesheet;
}

function update() {
  if (!stylesheet) return;
  stylesheet.innerHTML = styles.filter(item => item !== null).join('\n');
}

// Add CSS to stylesheet
export function add(css) {
  if (!stylesheet) init();

  const index = styles.indexOf(css);
  if (index > -1) return index;

  styles.push(css);
  update();
  return styles.length - 1;
}

// Remove CSS from stylesheet
export function remove(css) {
  if (!stylesheet) return;

  const index = styles.indexOf(css);
  if (index > -1) {
    styles[index] = null;
  }

  update();
}

// Remove CSS from stylesheet
export function removeAt(index) {
  if (!stylesheet || index > styles.length - 1) return;
  styles[index] = null;
  update();
}

// Remove all CSS from stylesheet
export function clear() {
  styles = [];
  update();
}
